module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_5010.d5939ce6.png";